import { useEffect, useState } from "react";
import "./style.css";

function CustomSearchInputV2({
    minimumLength = 3,
    handleChange = () => { },
    onclick = () => { }
}) {

    const [search, setSearch] = useState('');

    useEffect(() => {
        if (search?.length > minimumLength) {
            handleChange(search);
        } else if (search?.length == 0) {
            handleChange(search);
        }
    }, [search]);

    return (
        <div className="custom-search-input-v2">
            <div className="csi-v2-header">
                <span>Search</span>
            </div>
            <input type="text" value={search} onChange={(event) => {
                setSearch(event.target.value);
            }} />
        </div>
    );
}

export default CustomSearchInputV2;